import React from 'react';
import './App.css';

function App() {
  const siteName = 'Net Credit Quest';
  document.title = siteName;
  return <div className="App">{siteName}</div>;
}

export default App;
